/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as React from 'react'
import { useHistory } from 'react-router'

import zentakelogo from '@/assets/zentakelogo.svg'
import StripeForm from '@/components/Billing/StripeForm'
import useSearchParams from '@/hooks/useSearchParams'
import {
  invalidateLoadStripeCustomer,
  useLoadStripeCustomer,
} from '@/queries/payments/useLoadStripeCustomer'
import { TRIAL_FLOWS } from '@/utils/constants'
import { ZentakeContext } from '@/utils/ZentakeContext'

export function SetupCardPage() {
  const {
    updateUserDetails,
    fetchingUserDetails,
    setGlobalLoading,
    setTeamDetails,
    userDetails,
  } = React.useContext(ZentakeContext)

  const { data: stripeCustomer, isLoading: isFetchingStripeCustomer } =
    useLoadStripeCustomer()

  const history = useHistory()
  const params = useSearchParams()
  const redirect = params.get('redirect')

  React.useEffect(() => {
    async function fetchData() {
      await updateUserDetails()
      await invalidateLoadStripeCustomer()
    }

    fetchData().catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Error fetching data', error)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const historyPush = React.useCallback(
    (path: string | undefined = undefined) => {
      if (!path && redirect) {
        history.push(redirect)
      } else {
        history.push(path ?? '/')
      }
    },
    [history, redirect]
  )

  React.useEffect(() => {
    const { subscription_status, trial_flow, has_payment_method } =
      stripeCustomer ?? {}
    if (subscription_status === 'canceled') {
      historyPush('/closed-account')
      return
    }
    if (subscription_status === 'active') {
      // @ts-ignore
      setTeamDetails((teamDetails) => ({
        ...teamDetails,
        has_permission: true,
      }))
      historyPush()
      return
    }
    const alternative_subscription_status = userDetails?.subscription?.status
    if (
      trial_flow !== TRIAL_FLOWS.CREDIT_CARD_WITH_CHARGE &&
      has_payment_method &&
      (subscription_status === 'trialing' ||
        alternative_subscription_status === 'trialing')
    ) {
      // @ts-ignore
      setTeamDetails((teamDetails) => ({
        ...teamDetails,
        has_permission: true,
      }))
      historyPush()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stripeCustomer, history])

  React.useEffect(() => {
    if (!fetchingUserDetails && !isFetchingStripeCustomer) {
      setGlobalLoading(false)
    }
  }, [fetchingUserDetails, isFetchingStripeCustomer, setGlobalLoading])

  return (
    <div className="mt-4 flex flex-1 items-center justify-center">
      <div className="w-100 mx-2 grid max-w-screen-sm grid-cols-1 rounded border bg-white p-4">
        <img
          alt="ZENTAKE"
          className="block h-13 w-auto"
          src={zentakelogo}
          style={{ marginLeft: 'auto', marginRight: 'auto' }}
        />

        {/* {isAdminUser ? ( */}
        <StripeForm
          onChange={async () => {
            await invalidateLoadStripeCustomer()
          }}
          stripeCustomer={stripeCustomer}
        />
        {/* ) : ( */}
        {/* <ContactTeamAdmin /> */}
        {/* )} */}
      </div>
    </div>
  )
}
export default SetupCardPage
